// src/mockData.js
// ---------------------------------------------
// Données mock pour le portfolio Charles Ludig
// ---------------------------------------------

// === 🎥 PROJETS CINÉMA / STUDIO / MUSIQUE ===
export const projects = [
  {
    id: 1,
    title: "Les Vedettes",
    category: "cinema",
    image: "/images/les_vedettes.jpg",
    description: "Long-métrage avec musique originale",
    year: 2023,
  },
  {
    id: 2,
    title: "Bonne Conduite",
    category: "cinema",
    image: "/images/bonne_conduite.jpg",
    description: "Comédie dramatique - Composition originale",
    year: 2023,
  },
  {
    id: 3,
    title: "Max et Léon",
    category: "cinema",
    image: "/images/Max_et_leon.jpg",
    description: "Film comique - Musique originale",
    year: 2022,
  },
  {
    id: 4,
    title: "Studio",
    category: "studio",
    image: "/images/studio_level.jpg",
    description: "Studio d'enregistrement professionnel",
    link: "/studio",
  },
  {
    id: 5,
    title: "Une Nuit Infinie",
    category: "musique",
    image: "/images/une_nuit_infinie.jpg",
    description: "Album - Compositions originales",
    link: "/musique",
  },
  {
    id: 6,
    title: "Palmashow",
    category: "tvweb",
    image: "/images/palmashow.jpg",
    description:
      "Depuis leurs débuts, j'accompagne le Palmashow en tant que compositeur, preneur de son et responsable de la post production audio. Je signe l'ensemble de leurs musiques originales, notamment toutes leurs parodies musicales, que ce soit pour leurs émissions télé (TF1, et auparavant C8/D8/DIRECT 8) ou leurs longs-métrages.",
    year: "2010 - Présent",
    featured: true,
    link: "https://www.youtube.com/user/Palmashow",
  },
];

// === 📺 PROJETS TV / WEB ===
export const tvWebProjects = [
  {
    id: 1,
    title: "",
    image: "/images/palmashow.jpg",
    description:
      "Depuis leurs débuts, j'accompagne le Palmashow en tant que compositeur, preneur de son et responsable de la post production audio. Je signe l'ensemble de leurs musiques originales, notamment toutes leurs parodies musicales, que ce soit pour leurs émissions télé (TF1, et auparavant C8/D8/DIRECT 8) ou leurs longs-métrages.",
    featured: true,
    playlists: [
      {
        id: "PL76oDTZ7imia7B0GGeosHtIz_vpQZxby7",
        title: "Very Bad Blagues",
      },
      {
        id: "PL76oDTZ7imibhe68bFHxsLVQUcH00hxS-",
        title: "Ce soir c’est Palmashow",
      },
      {
        id: "PL76oDTZ7imiYZS4zHbssY2qX8Fgoapt2_",
        title: "La Folle Soirée 2",
      },
      {
        id: "PL76oDTZ7imiaP7LCzF8JWGdXPSvU_ADIR",
        title: "Les Clips du Palmashow",
      },
    ],
  },
  {
    id: 2,
    title: "BA PROD",
    image: "/images/BA PROD.png",
    description: "Compositeur et chef opérateur son sur divers projets institutionnels.",
    link: "http://ba-prod.com/",
  },
  {
    id: 3,
    title: "MMA",
    image: "/images/MMA.png",
    description: "Chef opérateur son pour publicités télé.",
    link: "https://teteschercheuses.fr/portfolio/films-fisher-price-real-thomas-leisten-schneider-prod-degaulle/",
  },
];


// === 🎵 ALBUMS SPOTIFY ===
export const spotifyAlbums = [
  {
    id: 1,
    url: "https://open.spotify.com/embed/album/32Nq0PqvHSna7KiERynrIK",
    title: "Une Nuit Infinie",
  },
  {
    id: 2,
    url: "https://open.spotify.com/embed/album/1ppGgR3cCSvEvO6p5F8p5M",
    title: "Bonne Conduite",
  },
  {
    id: 3,
    url: "https://open.spotify.com/embed/album/4hJoNiCzMMixBYefbAY0CF",
    title: "Les Vedettes",
  },
  {
    id: 4,
    url: "https://open.spotify.com/embed/album/2Ts1aTmF5gJbrMto1jTLDF",
    title: "Palmashow – L’Album",
  },
];

// === 📸 PHOTOS ===
export const photos = [
  {
    id: 1,
    url: "/images/Photograpghie.jpg",
    category: "perso",
    title: "",
  },
  {
    id: 2,
    url: "/images/1-751.jpg",
    category: "perso",
    title: "",
  },
  {
    id: 3,
    // petit bug corrigé : il manquait le "/" au début
    url: "/images/1-539.jpg",
    category: "perso",
    title: "",
  },
  {
    id: 4,
    url: "/images/1-532.jpg",
    category: "perso",
    title: "",
  },
  {
    id: 5,
    url: "/images/1-49.jpg",
    category: "perso",
    title: "",
  },
  {
    id: 6,
    url: "/images/1-288.jpg",
    category: "perso",
    title: "Salar d'Uyuni",
  },
  {
    id: 7,
    url: "/images/1-253.jpg",
    category: "perso",
    title: "",
  },

  // 👇 nouvelles photos perso que tu viens d'envoyer
  {
    id: 8,
    url: "/images/1-24.jpg",
    category: "perso",
    title: "Skyline et esplanade",
  },
  {
    id: 9,
    url: "/images/DSC_6601.png",
    category: "perso",
    title: "",
  },
  {
    id: 10,
    url: "/images/1-22.jpg",
    category: "perso",
    title: "Tours et colline",
  },
  {
    id: 11,
    url: "/images/1-131.jpg",
    category: "perso",
    title: "Chaîne de montagnes",
  },
  {
    id: 12,
    url: "/images/1-127.jpg",
    category: "perso",
    title: "Bus chargé",
  },
  {
    id: 13,
    url: "/images/1-1125.jpg",
    category: "perso",
    title: "Chaise dans la neige",
  },
  {
    id: 14,
    url: "/images/1-1109.jpg",
    category: "perso",
    title: "Rue enneigée",
  },
  {
    id: 15,
    url: "/images/1-110.jpg",
    category: "perso",
    title: "Palmiers au coucher de soleil",
  },
  {
    id: 16,
    url: "/images/1-641.jpg",
    category: "perso",
    title: "Architecture en alvéoles",
  },
  {
    id: 17,
    url: "/images/photo-8337.jpg",
    category: "tournage",
    title: "",
  },
  {
    id: 18,
    url: "/images/photo-7940.jpg",
    category: "tournage",
    title: "",
  },
];


// === 🎧 MORCEAUX AUDIO POUR MINI LECTEUR ===
export const audioTracks = [
  {
    id: 1,
    title: "REVEAL",
    artist: "Charles Ludig",
    url: "/audio/REVEAL_MSTR.mp3",
  },
   {
    id: 4,
    title: "CHURCH",
    artist: "Charles Ludig",
    url: "/audio/CHURCH.mp3",
  },
  {
    id: 2,
    title: "TIME",
    artist: "Charles Ludig",
    url: "/audio/BED TIME.mp3",
  },
  {
    id: 3,
    title: "CAPTURE",
    artist: "Charles Ludig",
    url: "/audio/CAPTURE.mp3",
  },
 

  {
    id: 6,
    title: "Démo Les Vedettes",
    artist: "Charles Ludig",
    url: "/audio/DEMO LES VEDETTES.mp3",
  },
  {
    id: 7,
    title: "Démo Max & Léon Syrie",
    artist: "Charles Ludig",
    url: "/audio/DEMO MAX & LEON SYRIE.mp3",
  },
  {
    id: 8,
    title: "Démo Nanana Palmashow",
    artist: "Charles Ludig",
    url: "/audio/DEMO NANANA PALMASHOW.mp3",
  },
  {
    id: 9,
    title: "EASTERN",
    artist: "Charles Ludig",
    url: "/audio/EASTERN.mp3",
  },
  {
    id: 10,
    title: "EPIC MOUSQUETAIRES",
    artist: "Charles Ludig",
    url: "/audio/EPIC MOUSQUETAIRES.mp3",
  },
  {
    id: 11,
    title: "FREEWAY",
    artist: "Charles Ludig",
    url: "/audio/FREEWAY.mp3",
  },
  {
    id: 12,
    title: "Générique Ce Soir C'est Palmashow",
    artist: "Charles Ludig",
    url: "/audio/GENERIQUE CE SOIR C'EST PALMASHOW.mp3",
  },
  {
    id: 13,
    title: "GIBSON",
    artist: "Charles Ludig",
    url: "/audio/GIBSON.mp3",
  },
  {
    id: 14,
    title: "GOODBYE",
    artist: "Charles Ludig",
    url: "/audio/GOODBYE.mp3",
  },
  {
    id: 15,
    title: "L'Aile ou la Cuisse Remix",
    artist: "Charles Ludig",
    url: "/audio/L'AILE OU LA CUISSE REMIX.mp3",
  },
  {
    id: 16,
    title: "PATIENCE",
    artist: "Charles Ludig",
    url: "/audio/PATIENCE.mp3",
  },
  {
    id: 17,
    title: "PIANO BEAT",
    artist: "Charles Ludig",
    url: "/audio/PIANO BEAT.mp3",
  },
  {
    id: 18,
    title: "ROADS",
    artist: "Charles Ludig",
    url: "/audio/ROADS.mp3",
  },
  {
    id: 19,
    title: "SARAH",
    artist: "Charles Ludig",
    url: "/audio/SARAH.mp3",
  },
  {
    id: 20,
    title: "SNOP",
    artist: "Charles Ludig",
    url: "/audio/SNOP.mp3",
  },
  {
    id: 21,
    title: "TENSIONS",
    artist: "Charles Ludig",
    url: "/audio/TENSIONS.mp3",
  },
  {
    id: 22,
    title: "TWO GUITARS",
    artist: "Charles Ludig",
    url: "/audio/TWO GUITARS.mp3",
  },
  {
    id: 23,
    title: "VERY BAD MUSIC",
    artist: "Charles Ludig",
    url: "/audio/VERY BAD MUSIC.mp3",
  },
];
// === 🌐 LIENS SOCIAUX ===
export const socialLinks = [
  { name: "Instagram", url: "https://instagram.com/charlesludig", icon: "Instagram" },
  { name: "Facebook", url: "https://facebook.com/charlesludig", icon: "Facebook" },
  { name: "TikTok", url: "https://tiktok.com/@charlesludig", icon: "Music" },
  { name: "LinkedIn", url: "https://linkedin.com/in/charlesludig", icon: "Linkedin" },
  { name: "SoundCloud", url: "https://soundcloud.com/charlesludig", icon: "Cloud" },
  { name: "YouTube", url: "https://youtube.com/@charlesludig", icon: "Youtube" },
];

// ---- Playlists officielles Palmashow (pour TvWeb.jsx) ----
export const palmashowPlaylists = [
  { id: 'PL76oDTZ7imia7B0GGeosHtIz_vpQZxby7', title: 'Very Bad Blagues' },
  { id: 'PL76oDTZ7imibhe68bFHxsLVQUcH00hxS-', title: "Ce soir c'est Palmashow" },
  { id: 'PL76oDTZ7imiYZS4zHbssY2qX8Fgoapt2_', title: 'La Folle Soirée 2' },
  { id: 'PL76oDTZ7imiaP7LCzF8JWGdXPSvU_ADIR', title: 'Clips du Palmashow' },
  { id: 'PL76oDTZ7imiZEokCU5pe_SvTHbgzPMA88', title: "Cannes Off" },
  { id: 'PL76oDTZ7imiaNCAVppY_GUMofOFEFthAv', title: "Ce soir c'est Palmashow 2" },
  { id: 'PL76oDTZ7imiYbPTXgwbN-BYRsQpofpIin', title: 'La Folle Soirée 3' },
  { id: 'PL76oDTZ7imiYgutvOd8pMocIRJXkc8V7E', title: 'La Folle Histoire' },
];

// === 📰 ACTUALITÉS / ARTICLES ===
export const blogPosts = [
  {
    id: 1,
    slug: "clip-la-sympathie-jonathan-barre",
    title: "CLIP : LA SYMPATHIE",
    excerpt: "Notre dernier clip \"LA SYMPATHIE\", avec JONATHAN BARRÉ.",
    content: "\n\n",
    image: "/images/LA SYMPATHIE.png",
    video_url: "https://www.youtube.com/embed/SiVaumRJiuc",
    
    published: true,
    created_at: "2026-01-01T15:30:00Z",
    updated_at: "2025-01-18T15:30:00Z"
  },
  {
    id: 2,
    slug: "NIKON FILM FESTIVAL 2026",
    title: "LE COLIS",
    excerpt: "Composition Musicale pour le film de FABIEN BENOIT",
    content: "\n\n",
    image: "/images/LE COLIS.jpeg",
    video_url: "https://www.youtube.com/embed/IZPGku9G6nI?si=tPY1pTzs_8wdu4KZ",
    
    published: true,
    created_at: "2026-01-15T15:30:00Z",
    updated_at: "2025-01-18T15:30:00Z"
  },
   {
   id: 3,
    slug: "LA BELLE AVENTURE",
    title: "LA BELLE AVENTURE",
    excerpt: "Mixage pour le film de  MATHIEU CONIGLIO ",
    content: "\n\n",
    image: "/images/LA BELLE AVENTURE.jpeg",
    video_url: "https://www.youtube.com/embed/l1R2t8g_g3M?si=UqW9LtEvVedXToTI",
  
    published: true,
    created_at: "2026-01-15T15:30:00Z",
    updated_at: "2025-01-18T15:30:00Z"
    
  },
  {
    id: 4,
    slug: "CHLOÉ",
    title: "CHLOÉ",
    excerpt: "Composition Musicale et Mixage pour le  film d'ÉDOUARD VASILIC",
    content: "\n\n",
    image: "/images/CHLOE.png",
    video_url: "https://www.youtube.com/embed/LzKlY9Psqfk?si=KPOSqfJvS__Ul4rA",
  
    published: true,
    created_at: "2025-07-30T15:30:00Z",
    updated_at: "2025-01-18T15:30:00Z"
  },
  {
    id: 5,
    slug: "FILM SYNC AWARDS 2025",
    title: "FILM SYNC AWARDS 2025",
    excerpt: "Finaliste / Proposition de nouvelle musique sur un extrait de film - IN THE MOOD FOR LOVE",
    content: "\n\n",
    image: "/images/FILM SYNC AWARDS.png",
    video_url: "/videos/REVEAL.mp4",
  
    published: true,
    created_at: "2025-06-30T15:30:00Z",
    updated_at: "2025-01-18T15:30:00Z"
  },
  {
    id: 6,
    slug: "pho",
    title: "PHÒ",
    excerpt: "Musique originale pour le court métrage. Voix off enregistrée dans mon studio.",
    content: "\n\n",
    image: "/images/PHO.jpg",
    video_url: "https://www.youtube.com/embed/HQTkziCwKJM",

    published: true,
    created_at: "2024-01-01T12:00:00Z",
    updated_at: "2024-01-01T12:00:00Z"
  },
  // AJOUTEZ VOS NOUVEAUX ARTICLES ICI
];
